function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { FormBlockColumn } from "@xo-union/tk-component-form-grid";
import { Checkbox } from "@xo-union/tk-component-switches";
import { useTrackImpression } from "@xo-union/tk-component-analytics";
import { Form, Field } from "@xo-union/tk-component-fields";
import { compose } from "@xo-union/react-css-modules";
import { NewWindowAnchor } from "@xo-union/component-standard-elements";
import { ModalHeader } from "@xo-union/ui-accessibility";
import { InlineAlert } from "@xo-union/tk-component-alerts";
import FormSubmitButton from "../Buttons/index.js";
import styles from "../../css/index.css";
import mapPropsToAnalyticsData from "./mapPropsToAnalyticsData/index.js";
import EmailFlags from "./EmailFlags.js";
import CanSpam from "../CanSpam/index.js";
import generateFormLinks from "../../utils/generateFormLinks/index.js";
var FormFooter = function FormFooter(_ref) {
  var onClickLogIn = _ref.onClickLogIn;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, "Already a member? \xA0", /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: styles.footerLink,
    onClick: onClickLogIn
  }, "Log in"), /*#__PURE__*/React.createElement("hr", null), "Are you a vendor? \xA0", /*#__PURE__*/React.createElement("a", {
    className: styles.footerLink,
    href: "https://www.theknot.com/vendors/home?itm_source=theknot.com&itm_medium=referral&itm_campaign=sign-up-modal"
  }, "Start here"));
};
process.env.NODE_ENV !== "production" ? FormFooter.propTypes = {
  onClickLogIn: PropTypes.func.isRequired
} : void 0;
var SignUpForm = function SignUpForm(props) {
  var Footer = props.Footer,
    header = props.header,
    Header = props.Header,
    inProgress = props.inProgress,
    initialFocusRef = props.initialFocusRef,
    metadata = props.metadata,
    onClickLogIn = props.onClickLogIn,
    onSubmit = props.onSubmit,
    subHeader = props.subHeader,
    emailProps = props.emailProps,
    passwordProps = props.passwordProps,
    alertProps = props.alertProps;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    emailOptIn = _React$useState2[0],
    setEmailOptin = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    email = _React$useState4[0],
    setEmail = _React$useState4[1];
  var _React$useState5 = React.useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    password = _React$useState6[0],
    setPassword = _React$useState6[1];
  var toggleOptIn = React.useCallback(function (e) {
    setEmailOptin(e.target.checked);
  }, []);
  useTrackImpression(mapPropsToAnalyticsData(props));
  var links = generateFormLinks();
  return /*#__PURE__*/React.createElement(CanSpam, null, function (_ref2) {
    var requireExplicitOptin = _ref2.requireExplicitOptin,
      ready = _ref2.ready;
    var finalEmailOptinValue = emailOptIn === null ? !requireExplicitOptin : emailOptIn;
    var handleSubmit = function handleSubmit(evt, originalEvent) {
      onSubmit(_objectSpread(_objectSpread({}, evt), {}, {
        data: {
          email: email,
          password: password,
          brand: 'theknot',
          action: metadata.userAction,
          application: metadata.applicationName,
          optins: finalEmailOptinValue ? EmailFlags.yes : EmailFlags.no
        }
      }), originalEvent);
    };
    if (!ready) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: styles.formContainer
    }, Header ? /*#__PURE__*/React.createElement(Header, null) : /*#__PURE__*/React.createElement(React.Fragment, null, header && /*#__PURE__*/React.createElement(ModalHeader, {
      className: styles.header
    }, header), subHeader && /*#__PURE__*/React.createElement("p", {
      className: styles.subHeader
    }, subHeader)), /*#__PURE__*/React.createElement(InlineAlert, _extends({
      classes: compose({
        container: styles.formAlert
      }),
      type: "error",
      visible: false
    }, alertProps), typeof (alertProps === null || alertProps === void 0 ? void 0 : alertProps.children) === 'function' ? alertProps.children(alertProps.data) : (alertProps === null || alertProps === void 0 ? void 0 : alertProps.data) || 'Something went wrong. Please try again.'), /*#__PURE__*/React.createElement(Form, {
      onSubmit: handleSubmit,
      "aria-busy": inProgress ? 'true' : undefined,
      "aria-label": "Create account"
    }, /*#__PURE__*/React.createElement(FormBlockColumn, null, /*#__PURE__*/React.createElement(Field, _extends({
      value: email,
      onChange: function onChange(evt) {
        return setEmail(evt.target.value);
      },
      validations: {
        email: true,
        required: true
      },
      type: "email",
      autoComplete: "email",
      name: "email",
      label: "Email address",
      ref: initialFocusRef
    }, emailProps))), /*#__PURE__*/React.createElement(FormBlockColumn, null, /*#__PURE__*/React.createElement(Field, _extends({
      value: password,
      onChange: function onChange(evt) {
        return setPassword(evt.target.value);
      },
      name: "password",
      type: "password",
      label: "Password",
      autoComplete: "new-password"
      /* Validation props */,
      validations: {
        required: true,
        minLength: 6
      },
      subTextOnValid: "Password is valid"
    }, passwordProps))), /*#__PURE__*/React.createElement("div", {
      className: styles.formSubText
    }, /*#__PURE__*/React.createElement("small", null, "By clicking \u2018Sign up\u2019, I agree to The Knot's\xA0", /*#__PURE__*/React.createElement(NewWindowAnchor, {
      href: links.PRIVACY_POLICY
    }, "Privacy Policy"), ' ', "and\xA0", /*#__PURE__*/React.createElement(NewWindowAnchor, {
      href: links.TERMS_AND_CONDITIONS
    }, "Terms of Use"), ". I understand The Knot may share my information with partners as described\xA0", /*#__PURE__*/React.createElement(NewWindowAnchor, {
      href: links.PRIVACY_POLICY
    }, "here"), ".")), /*#__PURE__*/React.createElement(FormSubmitButton, {
      isLoading: inProgress
    }, "Sign up"), requireExplicitOptin && /*#__PURE__*/React.createElement("div", {
      className: styles.emailOptinContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.emailOptinCenter
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: finalEmailOptinValue,
      onChange: toggleOptIn,
      name: "emailOptIn",
      value: "true"
    }, "Send me wedding ideas, tips, and special offers!")))), /*#__PURE__*/React.createElement(Footer, {
      onClickLogIn: onClickLogIn
    }));
  });
};
process.env.NODE_ENV !== "production" ? SignUpForm.propTypes = {
  /**
   * Will be called when clicking on CTA to switch to log in view
   */
  onClickLogIn: PropTypes.func.isRequired,
  /**
   * Form submission callback
   */
  onSubmit: PropTypes.func.isRequired,
  /**
   * Used to display loading CTA
   */
  inProgress: PropTypes.bool,
  /**
   * For analytics
   */
  metadata: PropTypes.shape({
    applicationName: PropTypes.string,
    userAction: PropTypes.string
  }).isRequired,
  /**
   * Used to override the header copy, while preserving the current subHeader
   */
  header: PropTypes.node,
  /**
   * Used to override the subHeader copy, while preserving the header
   */
  subHeader: PropTypes.node,
  /**
   * Used to override the footer section
   */
  Footer: PropTypes.func,
  /**
   * Used to override the header section (replaces the header and subHeader)
   */
  Header: PropTypes.func,
  /**
   * Element to set as the initial focus
   */
  initialFocusRef: PropTypes.shape({
    current: PropTypes.shape()
  }),
  /**
   * Used to set additional props on the email field
   */
  emailProps: PropTypes.shape(),
  /**
   * Used to set additional props on the password field
   */
  passwordProps: PropTypes.shape(),
  /**
   * Used to set additional props on the alert
   */
  alertProps: PropTypes.shape()
} : void 0;
SignUpForm.defaultProps = {
  inProgress: false,
  header: 'Your personal wedding plan starts now',
  subHeader: '',
  Footer: FormFooter,
  Header: null,
  emailProps: {},
  passwordProps: {}
};
export default SignUpForm;